import { supabase } from '../../lib/supabase'

export type DecideScheduleSubmissionParams = {
  scheduleSubmissionId: string
  decision: 'approve' | 'return' | 'deny'
  comment?: string
}

// The only path to approve, return, or deny a real schedule submission:
// v1-decide-schedule-submission (supabase/functions/v1-decide-schedule-submission)
// records the decision and moves the schedule_submissions row's own state
// in one transaction, mirroring leaveDecisionStore.ts's own
// decideLeaveRequest exactly. Returns whether it landed, the same as
// every other decide function in this workspace.
export async function decideScheduleSubmission(params: DecideScheduleSubmissionParams): Promise<boolean> {
  const { error } = await supabase.functions.invoke('v1-decide-schedule-submission', { body: params })
  return !error
}

export type ReverseScheduleDecisionParams = { scheduleSubmissionId: string; reason: string }

// Takes back an approval, returning the submission to submitted for a new
// decision. v1-reverse-schedule-decision refuses a submission that is not
// approved, one whose pay period has ended, and one the team has published, so
// this reports the refusal's own wording where there is one.
export async function reverseScheduleDecision(params: ReverseScheduleDecisionParams): Promise<{ ok: true } | { ok: false; message: string }> {
  const { error } = await supabase.functions.invoke('v1-reverse-schedule-decision', { body: params })
  if (!error) return { ok: true }

  let message = error.message
  const context = (error as { context?: { json?: () => Promise<{ error?: string }> } }).context
  if (context?.json) {
    try {
      const body = await context.json()
      if (body.error) message = body.error
    } catch {
      // The body was not JSON; the error's own message stands.
    }
  }
  return { ok: false, message: message || 'The approval could not be reversed. Try again.' }
}
